"use strict";

var _classCallCheck = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var _require = require("../helpers/strings"),
    parseFloatingPointNumber = _require.parseFloatingPointNumber;

var _require2 = require("../helpers/form-controls"),
    getLabelsForLabelable = _require2.getLabelsForLabelable;

var HTMLMeterElementImpl = /*#__PURE__*/function (_HTMLElementImpl) {
  _inherits(HTMLMeterElementImpl, _HTMLElementImpl);

  var _super = _createSuper(HTMLMeterElementImpl);

  function HTMLMeterElementImpl(args, privateData) {
    var _this;

    _classCallCheck(this, HTMLMeterElementImpl);

    _this = _super.call(this, args, privateData);
    _this._labels = null;
    return _this;
  } // https://html.spec.whatwg.org/multipage/form-elements.html#concept-meter-minimum


  _createClass(HTMLMeterElementImpl, [{
    key: "_minimumValue",
    get: function get() {
      var min = this.getAttribute("min");

      if (min === null) {
        return 0;
      }

      var parsed = parseFloatingPointNumber(min);

      if (Number.isNaN(parsed)) {
        return 0;
      }

      return parsed;
    } // https://html.spec.whatwg.org/multipage/form-elements.html#concept-meter-maximum

  }, {
    key: "_maximumValue",
    get: function get() {
      var candidate = 1.0;
      var max = this.getAttribute("max");

      if (max !== null) {
        var parsed = parseFloatingPointNumber(max);

        if (!Number.isNaN(parsed)) {
          candidate = parsed;
        }
      }

      var minimumValue = this._minimumValue;
      return candidate >= minimumValue ? candidate : minimumValue;
    } // https://html.spec.whatwg.org/multipage/form-elements.html#concept-meter-actual

  }, {
    key: "_actualValue",
    get: function get() {
      var candidate = 0;
      var value = this.getAttribute("value");

      if (value !== null) {
        var parsed = parseFloatingPointNumber(value);

        if (!Number.isNaN(parsed)) {
          candidate = parsed;
        }
      }

      var minimumValue = this._minimumValue;

      if (candidate < minimumValue) {
        return minimumValue;
      }

      var maximumValue = this._maximumValue;
      return candidate > maximumValue ? maximumValue : candidate;
    } // https://html.spec.whatwg.org/multipage/form-elements.html#concept-meter-low

  }, {
    key: "_lowBoundary",
    get: function get() {
      var minimumValue = this._minimumValue;
      var candidate = minimumValue;
      var low = this.getAttribute("low");

      if (low !== null) {
        var parsed = parseFloatingPointNumber(low);

        if (!Number.isNaN(parsed)) {
          candidate = parsed;
        }
      }

      if (candidate < minimumValue) {
        return minimumValue;
      }

      var maximumValue = this._maximumValue;
      return candidate > maximumValue ? maximumValue : candidate;
    } // https://html.spec.whatwg.org/multipage/form-elements.html#concept-meter-high

  }, {
    key: "_highBoundary",
    get: function get() {
      var maximumValue = this._maximumValue;
      var candidate = maximumValue;
      var high = this.getAttribute("high");

      if (high !== null) {
        var parsed = parseFloatingPointNumber(high);

        if (!Number.isNaN(parsed)) {
          candidate = parsed;
        }
      }

      var lowBoundary = this._lowBoundary;

      if (candidate < lowBoundary) {
        return lowBoundary;
      }

      return candidate > maximumValue ? maximumValue : candidate;
    } // https://html.spec.whatwg.org/multipage/form-elements.html#concept-meter-optimum

  }, {
    key: "_optimumPoint",
    get: function get() {
      var minimumValue = this._minimumValue;
      var maximumValue = this._maximumValue;
      var candidate = (minimumValue + maximumValue) / 2;
      var optimum = this.getAttribute("optimum");

      if (optimum !== null) {
        var parsed = parseFloatingPointNumber(optimum);

        if (!Number.isNaN(parsed)) {
          candidate = parsed;
        }
      }

      if (candidate < minimumValue) {
        return minimumValue;
      }

      return candidate > maximumValue ? maximumValue : candidate;
    }
  }, {
    key: "labels",
    get: function get() {
      return getLabelsForLabelable(this);
    }
  }, {
    key: "value",
    get: function get() {
      return this._actualValue;
    },
    set: function set(val) {
      this.setAttribute("value", String(val));
    }
  }, {
    key: "min",
    get: function get() {
      return this._minimumValue;
    },
    set: function set(val) {
      this.setAttribute("min", String(val));
    }
  }, {
    key: "max",
    get: function get() {
      return this._maximumValue;
    },
    set: function set(val) {
      this.setAttribute("max", String(val));
    }
  }, {
    key: "low",
    get: function get() {
      return this._lowBoundary;
    },
    set: function set(val) {
      this.setAttribute("low", String(val));
    }
  }, {
    key: "high",
    get: function get() {
      return this._highBoundary;
    },
    set: function set(val) {
      this.setAttribute("high", String(val));
    }
  }, {
    key: "optimum",
    get: function get() {
      return this._optimumPoint;
    },
    set: function set(val) {
      this.setAttribute("optimum", String(val));
    }
  }]);

  return HTMLMeterElementImpl;
}(HTMLElementImpl);

module.exports = {
  implementation: HTMLMeterElementImpl
};